// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","title":"styles_title__oTGN5","experience":"styles_experience__BTl4U","contact":"styles_contact__a579G","about":"styles_about__6B2nj"};